import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

function applyTenantBranding(tenant) {
  if (!tenant) return;
  const root = document.documentElement;
  if (tenant.primary_color) {
    root.style.setProperty('--accent', tenant.primary_color);
    root.style.setProperty('--border-focus', tenant.primary_color);
    const r = parseInt(tenant.primary_color.slice(1,3),16);
    const g = parseInt(tenant.primary_color.slice(3,5),16);
    const b = parseInt(tenant.primary_color.slice(5,7),16);
    root.style.setProperty('--accent-glow', `rgba(${r},${g},${b},0.12)`);
    root.style.setProperty('--accent-hover', tenant.primary_color + 'cc');
  }
  if (tenant.background_color) root.style.setProperty('--bg-primary', tenant.background_color);
  if (tenant.secondary_color) root.style.setProperty('--bg-secondary', tenant.secondary_color);
  if (tenant.font_family) root.style.setProperty('--font-family', tenant.font_family);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('crm_token');
    const savedTenant = localStorage.getItem('crm_tenant');
    if (savedTenant) {
      try { const t = JSON.parse(savedTenant); setTenant(t); applyTenantBranding(t); } catch {}
    }
    if (token) {
      api.get('/auth/verify')
        .then(res => {
          setUser(res.data.user);
          if (res.data.tenant) {
            setTenant(res.data.tenant);
            localStorage.setItem('crm_tenant', JSON.stringify(res.data.tenant));
            applyTenantBranding(res.data.tenant);
          }
        })
        .catch(() => { localStorage.removeItem('crm_token'); localStorage.removeItem('crm_tenant'); })
        .finally(() => setLoading(false));
    } else { setLoading(false); }
  }, []);

  const login = async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    localStorage.setItem('crm_token', res.data.token);
    setUser(res.data.user);
    if (res.data.tenant) {
      setTenant(res.data.tenant);
      localStorage.setItem('crm_tenant', JSON.stringify(res.data.tenant));
      applyTenantBranding(res.data.tenant);
    }
    return res.data;
  };

  const logout = () => { localStorage.removeItem('crm_token'); localStorage.removeItem('crm_tenant'); setUser(null); setTenant(null); };

  return <AuthContext.Provider value={{ user, tenant, login, logout, loading }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
